











































































































import AbpBase from "@/lib/abpbase";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
  DeleteGcpMedicine,
  DeleteGcpInspect,
  GetGcpInspect,
  GetGcpMedicine,
  SaveGoodClinicalPracticeUp,
  DeleteGcp,
  GetGcp,
} from "@/api/hd";
import util from "@/lib/util";
import medicine from "./medicine.vue";
import inspect from "./inspect.vue";
import practice from "./practice.vue";
import ajax from "axios";

@Component({
  components: { medicine, inspect, practice },
})
export default class extends AbpBase {
  @Prop() patient: any;
  QueryString = "";
  list: any = [];
  inspectList: any = [];
  medicineList: any = [];
  table: any = {
    loading: false,
    detailLoading: false,
  };
  inspectShow = false;
  inspectData: any = {};
  medicineShow = false;
  medicineData: any = {};
  detailInfo: any = {};
  practiceShow = false;
  loading = false;
  dataShow = false;
  oldRow: any = null;
  //表格高度
  get tableHeight() {
    return window.innerHeight - 100;
  }
  async created() {
    console.log(this.patient);
    await this.getData();
  }
  async getData() {
    console.log(this.$route.meta.title);
    this.table.loading = true;
    this.dataShow = false;
    let res = await GetGcp({
      QueryString: this.QueryString,
      PatientId: this.patient.pD_Patient_ID,
    });
    this.list = res.objects;
    this.table.loading = false;
    this.practiceShow = false;
    if (this.list) {
      if (this.oldRow) {
        await this.tabChange(this.oldRow, null);
      } else {
        await this.tabChange(this.list[0], null);
      }
    }
  }
  async delPractice() {
    this.$Modal.confirm({
      title: "提示",
      content: "此操作将永久删除该记录, 是否继续?",
      onOk: async () => {
        let res = await DeleteGcp({ Id: this.detailInfo.id });
        this.oldRow = null;
        await this.getData();
      },
    });
  }
  async getGcpInspect(row: any) {
    let res = await GetGcpInspect({ id: row.id });
    this.inspectList = res.objects;
  }

  async getGcpMedicine(id: any) {
    let res = await GetGcpMedicine({ id: id });
    this.medicineList = res.objects;
  }
  //tab选择
  tabChange(currentRow: any, oldCurrentRow: any) {
    if (currentRow) {
      this.detailInfo = currentRow;
      this.detailInfo.startTime = this.formatDateTime(
        this.detailInfo.startTime
      );
      this.detailInfo.endTime = this.formatDateTime(this.detailInfo.endTime);
      this.getGcpInspect(currentRow);
      this.getGcpMedicine(currentRow.id);
      this.oldRow = currentRow;
      this.dataShow = true;
    }
  }
  add() {
    this.inspectData.title = "新增";
    this.inspectData.info = this.detailInfo;
    this.inspectData.row = {};
    this.inspectShow = true;
  }
  edit(row: any) {
    this.inspectData.title = "编辑";
    this.inspectData.info = this.detailInfo;
    this.inspectData.row = row;
    this.inspectShow = true;
  }
  async save() {
    this.detailInfo.startTime = this.formatDateTime(this.detailInfo.startTime);
    this.detailInfo.endTime = this.formatDateTime(this.detailInfo.endTime);
    await SaveGoodClinicalPracticeUp(this.detailInfo);
    await this.getData();
  }
  async del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "此操作将永久删除该检测记录, 是否继续?",
      onOk: async () => {
        let res = await DeleteGcpInspect({ Id: row.id });
        this.getGcpInspect(this.detailInfo);
      },
    });
  }
  addMedicine() {
    console.log(this.medicineData);
    this.medicineData.title = "新增";
    this.medicineData.info = this.detailInfo;
    this.medicineData.row = {};
    this.medicineShow = true;
  }
  editMedicine(row: any) {
    this.medicineData.title = "编辑";
    this.medicineData.info = this.detailInfo;
    this.medicineData.row = row;
    this.medicineShow = true;
  }

  async delMedicine(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "此操作将永久删除该发药记录, 是否继续?",
      onOk: async () => {
        let res = await DeleteGcpMedicine({ Id: row.id });
        this.getGcpMedicine(this.detailInfo.id);
      },
    });
  }
  addPractice() {
    this.practiceShow = true;
  }

  column = [
    {
      title: "项目名称",
      key: "projectName",
    },
    {
      title: "开始时间",
      key: "startTime",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDate(params.row.startTime));
      },
    },
    {
      title: "状态",
      key: "statusStr",
    },
  ];
  inspectColumn = [
    {
      title: "检查项目",
      key: "inspectionItems",
    },
    {
      title: "计量单位",
      key: "unit",
    },
    {
      title: "单项费用",
      key: "cost",
    },
    {
      title: "标准要求",
      key: "requirement",
    },
    {
      title: "检验科室",
      key: "department",
    },
    {
      title: "检测方法",
      key: "method",
    },
    {
      title: "分析人",
      key: "analyst",
    },
    {
      title: "分析时间",
      key: "analysisDate",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDate(params.row.analysisDate));
      },
    },
    {
      title: "创建人",
      key: "creatorUser",
    },
    {
      title: "创建时间",
      key: "creationTime",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDateTime3(params.row.creationTime));
      },
    },
    {
      title: "操作",
      width: 180,
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        let isdefaultDom: any;
        return h("div", [
          isdefaultDom,
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  this.edit(params.row);
                },
              },
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: { type: "error", size: "small" },
              on: {
                click: () => {
                  this.del(params.row);
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];

  medicineColumn = [
    {
      title: "发药时间",
      key: "medicineDate",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDate(params.row.medicineDate));
      },
    },
    {
      title: "药名",
      key: "medicineName",
    },
    {
      title: "药量",
      key: "medicineValue",
    },
    {
      title: "次数",
      key: "medicineNum",
    },
    {
      title: "下次预计发药时间",
      key: "nextMedicineDate",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDate(params.row.nextMedicineDate));
      },
    },
    {
      title: "创建人",
      key: "creatorUser",
    },
    {
      title: "创建时间",
      key: "creationTime",
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        return h("span", this.formatDateTime3(params.row.creationTime));
      },
    },
    {
      title: "操作",
      width: 180,
      render: (h1: any, params: any) => {
        const h = this.$createElement;
        let isdefaultDom: any;
        return h("div", [
          isdefaultDom,
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "15px",
              },
              on: {
                click: () => {
                  this.editMedicine(params.row);
                },
              },
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: { type: "error", size: "small" },
              on: {
                click: () => {
                  this.delMedicine(params.row);
                },
              },
            },
            "删除"
          ),
        ]);
      },
    },
  ];

  // 将内容推送到小程序端
  pushMsg() {
    if (!this.detailInfo || !this.detailInfo.id) {
      return;
    }

    let msgContent = {
      id: this.detailInfo.id,
      projectNo: this.detailInfo.projectNo,
      projectName: this.detailInfo.projectName,
      startTime: this.detailInfo.startTime,
      medicineList: this.medicineList,
    };
    let payload = {
      Pusher: this.$store.state.session.user.userName,
      PushTime: new Date(),
      Receiver: this.patient.identityCard,
      MessageContent: JSON.stringify(msgContent),
      ProjectCode: this.detailInfo.projectNo,
    };
    console.log(payload);

    this.$Loading.start();
    let url = `${MINI_API_URL}/api/HDGcp/PushMessage`;
    ajax
      .post(url, payload, { timeout: 60000 })
      .then((res: any) => {
        this.$Loading.finish();
        if (res.data.code === 2000) {
          this.$Message.success("推送成功");
        } else {
          this.$Modal.error({
            title: "提示",
            content: res.data.message,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.$Loading.error();
        this.$Modal.error({
          title: "提示",
          content: "推送失败",
        });
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gcpManage/parts/gcpPractice/index.vue